module.exports = __webpack_public_path__ + "img/turntable.1dee45f9.png";